import { useEffect, useState } from 'react';

const useCompareModalScrolling = (scrollingObj) => {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const tableEl = document.querySelector('.compare-table');
      const scrolledHeaderEl = document.querySelector(
        '.compare-header--scrolled-state'
      );
      const modalHeaderEl = document.querySelector('.modal-header');
      const tableElDimensions = tableEl.getBoundingClientRect();
      const tableElFromTop = tableElDimensions.top;
      const scrolledHeaderElHeight = scrolledHeaderEl.getBoundingClientRect()
        .height;
      const modalHeaderElHeight = modalHeaderEl.getBoundingClientRect().height;

      if (
        !scrolling &&
        tableElFromTop < scrolledHeaderElHeight + modalHeaderElHeight
      ) {
        setScrolling(true);
      }
      if (
        scrolling &&
        tableElFromTop > scrolledHeaderElHeight + modalHeaderElHeight
      ) {
        setScrolling(false);
      }
    };

    if (scrollingObj) {
      scrollingObj.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollingObj) {
        scrollingObj.removeEventListener('scroll', handleScroll);
      }
    };
  }, [scrolling, scrollingObj]);

  return [scrolling, setScrolling];
};

export const useCompareModalIsScrolledUp = (scrollingObj) => {
  const [isScrolledUp, setIsScrolledUp] = useState(false);

  useEffect(() => {
    let previousYOffset = scrollingObj?.scrollTop;

    const updateScrolledUp = () => {
      const currentYOffset = scrollingObj.scrollTop;
      setIsScrolledUp(currentYOffset < previousYOffset ? true : false);
      previousYOffset = currentYOffset;
    };
    scrollingObj?.addEventListener('scroll', updateScrolledUp);
    return () => {
      scrollingObj?.removeEventListener('scroll', updateScrolledUp);
    };
  }, [isScrolledUp, scrollingObj]);

  return [isScrolledUp, setIsScrolledUp];
};

export const compareModalScrollToRef = (ref) => {
  const scrollingObj = document.querySelector('.modal-body');
  scrollingObj.scroll(0, 0);
  const compareHeaderEl = document.querySelector(
    '.compare-header--scrolled-state'
  );
  const compareHeaderElBottom = compareHeaderEl.getBoundingClientRect().bottom;
  const refElTop = ref.current.getBoundingClientRect().top;

  const offset = Math.trunc(refElTop - compareHeaderElBottom);
  scrollingObj.scroll(0, offset);
};

export default useCompareModalScrolling;
